import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Verifica si las variables de entorno están disponibles
if (!supabaseUrl || !supabaseKey) {
  console.error('Falta la URL o la clave de Supabase');
}

const supabase = createClient(supabaseUrl, supabaseKey);

export { supabase };
